import { ReactNode } from 'react';
import { Heading } from '@kinesis/bungle';

const Title = (props: TitleProps) => {
  const { children } = props;
  return (
    <Heading as='h2' size='large'>
      {children}
    </Heading>
  );
};

type TitleProps = {
  children: ReactNode;
};
export { Title };
